import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-vh-100 bg-light">
      <Header />
      <div className="d-flex">
        <Sidebar />
        <main className="flex-grow-1 p-4">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;